// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"51e4626b","695":"d2574874","787":"94973c74"}[chunkId] + ".chunk.js";
};